import React, { useState, useEffect } from 'react';
import { hayVersionNueva } from '../utils/version';

// Barra discreta que aparece cuando hay una versión nueva publicada.
//
// No se recarga sola: alguien puede estar en mitad de anotar un cobro y
// perdería lo escrito. Se avisa y decide la persona.

const CADA_MEDIA_HORA = 30 * 60 * 1000;

function AvisoDeVersion() {
  const [hayNueva, setHayNueva] = useState(false);

  useEffect(() => {
    let vivo = true;

    const comprobar = async () => {
      // Sin conexión no tiene sentido preguntar, y una vez avisado no hace
      // falta seguir comprobando.
      if (!navigator.onLine || !vivo) return;
      if (await hayVersionNueva()) {
        if (vivo) setHayNueva(true);
      }
    };

    const reloj = setInterval(comprobar, CADA_MEDIA_HORA);

    // Al volver a la aplicación tras dejarla en segundo plano, que es
    // justamente cuando más probable es que se haya quedado atrás.
    const alVolver = () => {
      if (document.visibilityState === 'visible') comprobar();
    };
    document.addEventListener('visibilitychange', alVolver);

    comprobar();

    return () => {
      vivo = false;
      clearInterval(reloj);
      document.removeEventListener('visibilitychange', alVolver);
    };
  }, []);

  if (!hayNueva) return null;

  return (
    <div style={{
      position: 'fixed',
      left: '50%',
      bottom: '18px',
      transform: 'translateX(-50%)',
      zIndex: 9998,
      display: 'flex',
      alignItems: 'center',
      gap: '14px',
      background: '#1f2937',
      color: 'white',
      padding: '12px 16px',
      borderRadius: '10px',
      boxShadow: '0 8px 24px rgba(0,0,0,.3)',
      fontSize: '14px',
      maxWidth: 'calc(100vw - 24px)'
    }}>
      <span>Hay una versión nueva de FlexFlow</span>
      <button
        onClick={() => window.location.reload()}
        style={{
          padding: '7px 14px',
          borderRadius: '6px',
          border: 'none',
          background: '#667eea',
          color: 'white',
          fontWeight: 'bold',
          cursor: 'pointer',
          fontSize: '14px',
          whiteSpace: 'nowrap'
        }}
      >
        Actualizar
      </button>
      <button
        onClick={() => setHayNueva(false)}
        title="Ahora no"
        style={{
          background: 'none',
          border: 'none',
          color: '#9ca3af',
          cursor: 'pointer',
          fontSize: '18px',
          lineHeight: 1,
          padding: '0 2px'
        }}
      >
        ×
      </button>
    </div>
  );
}

export default AvisoDeVersion;
